import React from 'react';
const ChatContext = React.createContext<any>(null);
export default ChatContext;
